export default "<p>editing-toolbar works!</p>\n"